import { useState } from 'react'
import Form from '../Form'
import { ZIP_RADIUS } from '@store/constants'
import ZipField from './ZipField'
import styled from 'styled-components'
import { Button } from '@favordelivery/tupperware'
import { mediaMobile, mediaTablet, mediaTabletAndMobile } from '../styles/breakPoints'
import { ErrorMsg } from '../Input'
import PartOf from '../../icons/PartOf'
import { t, tStr } from '@utils/lang'

const Container = styled.div`
  padding: 80px 112px;
  background-image: url(/images/ZipField.png);
  background-size: cover;
  background-repeat: no-repeat;
  height: 864px;
  background-blend-mode: color;
  @media (prefers-color-scheme: dark) {
    background-color: rgb(0 0 0 / 0.2);
  }

  > div {
    max-width: 1256px;
    position: relative;
    margin: 0 auto;
  }

  ${mediaTablet} {
    height: 628px;
    padding: 60px 48px;
  }

  ${mediaMobile} {
    height: auto;
    background: none;
    padding: 0;
    &::after {
      content: '';
      height: 452px;
      width: 100%;
      display: block;
      background-position: right;
      background-image: url(/images/ZipField.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-blend-mode: color;
      @media (prefers-color-scheme: dark) {
        background-color: rgb(0 0 0 / 0.2);
      }
    }
  }
`

const ContentBox = styled.div`
  padding: 48px;
  border-radius: 48px;
  overflow: hidden;
  width: 690px;
  box-shadow: 0px 8px 48px 0px var(--themeColorShadow);
  position: relative;
  backdrop-filter: blur(24px);
  z-index: 1;
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--themeColorBetaBgBrown);
    opacity: 0.8;
  }

  ${mediaTablet} {
    padding: 40px;
    width: 500px;
    border-radius: 40px;
  }
  ${mediaMobile} {
    padding: 24px;
    width: 100%;
    border-radius: 0;
  }
`
const HEBImg = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;

  ${mediaTabletAndMobile} {
    gap: 8px;
    img {
      height: 30px;
    }
    svg {
      width: auto;
      height: 23px;
    }
  }
`
const Title = styled.div`
  color: var(--themeColorBetaBrandHeader);
  font-family: ${p => p.theme.font.family.header};
  font-size: 100px;
  line-height: ${p => p.theme.font.lineHeight};
  text-transform: uppercase;
  letter-spacing: -1.12px;
  ${mediaTabletAndMobile} {
    font-size: 56px;
    letter-spacing: -0.56px;
  }
`
const SubTitle = styled.div`
  color: var(--themeColorBetaSecondary);
  font-size: ${p => p.theme.font.size.h4};
  font-weight: ${p => p.theme.font.weight.normal};
  line-height: ${p => p.theme.font.lineHeight};
  letter-spacing: -0.48px;
  margin: 16px 0 32px;
  ${mediaTabletAndMobile} {
    font-size: ${p => p.theme.font.size.title};
    letter-spacing: -0.32px;
    margin: 12px 0 32px;
  }
`
const ZipLine = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  ${mediaMobile} {
    flex-direction: column;
    align-items: stretch;
  }
`

const SubText = styled.div`
  color: var(--themeColorBetaSecondary);
  font-size: ${p => p.theme.font.size.caption};
  font-style: italic;
  font-weight: ${p => p.theme.font.weight.light};
  margin-top: 16px;
  a {
    color: var(--themeColorBetaSecondary);
    text-decoration: underline;
  }
`

const SignUpStep1 = props => {
  const { onZipComplete } = props

  const [zipErr, setZipErr] = useState(null)
  const [zip, setZip] = useState('')

  const zipIsValid = zipCode => zipCode.length === 5 && zipCode !== '00000'

  const validateZip = () => {
    if (!zipIsValid(zip)) {
      setZipErr(tStr('homeZipInvalid_s'))
      return false
    }
    setZipErr(null)
    return true
  }

  const getMarkets = e => {
    e.preventDefault()
    if (validateZip()) {
      onZipComplete(zip, ZIP_RADIUS)
    }
  }

  return (
    <Container>
      <div>
        <ContentBox>
          <HEBImg role="figure" aria-label={tStr('homeHeroHebLabel_s')}>
            <PartOf />
            <img src="/images/HEBLogo.svg" alt="" />
          </HEBImg>
          <Title>{t('homeHeroTitle_s')}</Title>
          <SubTitle>{t('homeHeroSubtitle_s')}</SubTitle>
          <Form className="form" onSubmit={getMarkets}>
            <ZipLine>
              <ZipField
                name="zipcode"
                autoComplete="off"
                onChange={zipCode => {
                  setZip(zipCode)
                  if (zipIsValid(zipCode)) {
                    setZipErr(null)
                  }
                }}
                onBlur={validateZip}
                error={zipErr}
                value={zip}
              />
              <Button type="submit">{t('homeHeroCta_s')}</Button>
            </ZipLine>
            <ErrorMsg>{zipErr}</ErrorMsg>

            <SubText>
              {t('homeHeroLegal_s', {
                ppLink: <a href="https://www.favordelivery.com/privacy">{t('privacyPolicy_s')}</a>,
                tosLink: <a href="https://www.favordelivery.com/tos">{t('termsOfService_s')}</a>
              })}
            </SubText>
          </Form>
        </ContentBox>
      </div>
    </Container>
  )
}

export default SignUpStep1
